import Logo from "../../assets/images/png/omniLogo.png";
import BodyWeightImg from "../../assets/images/png/bodyWeight.png";
import DailyMacrosImg from "../../assets/images/png/dailyMacros.png";
import DigitalJournal from "../../assets/images/webp/overviewPage/digitalJournalNews.webp";
import "./index.scss";

const HomeTownFitness = () => (
  <div className="article-update">
    <div className="article-source">
      <div className="text">Source:</div>
      <div className="date">Digital Journal</div>
      <img className="source-img" src={DigitalJournal} alt="" />
    </div>
    <div className="article-source">
      <div className="text">Posted on:</div>
      <div className="date">April 27, 2022</div>
    </div>
    <div className="title space">
      Omni-Active® Fitness, a hometown fitness business, makes a post-pandemic pivot to meet the demands of fitness
      consumers
    </div>
    <div className="text">
      Omni-Active® Fitness introduces a game-changing personal training app that features online workout programs that
      would get fitness enthusiasts the results they’re looking for.
    </div>
    <div className="company-img">
      <img className="company-logo" src={Logo} alt="" />
    </div>
    <div className="text">
      With the COVID pandemic changing the fitness industry landscape, Omni-Active® Fitness has led the charge in
      providing a fitness app that features one-on-one training sessions and online workout sessions, taking
      individuals’ personal fitness journey to the next level.
    </div>
    <div className="text">
      Nithanial Decker, the founder of Omni-Active®, says with fitness consumers now utilizing a wide array of services
      and solutions as the world enters a post-pandemic era, Omni-Active® Fitness has pivoted to make change not only to
      survive but to greatly improve for the future for employees and clients alike.
    </div>
    <div className="screen-img">
      <img className="screenshot-img" src={BodyWeightImg} alt="" />
    </div>

    <div className="text">
      Omni-Active® Fitness has been offering on-site and in-home personal training in the Greater Cleveland area since
      2012.
    </div>
    <div className="text">
      “Convenience has always been our driving force. People would think that when no one wanted to leave their house,
      things would’ve picked up for us, but with so much uncertainty, people tended to shut down and keep to themselves.
      Virtual workouts via FaceTime picked up after a while, which kept us afloat. Like most fitness companies during
      the pandemic, we stumbled,” Nithanial shares.
    </div>
    <div className="text">
      The pandemic served as a litmus test for Omni-Active® Fitness’ ability to thrive, says Nithanial, and it has paved
      the way for the team to rethink strategies and services that cater to the changing needs of fitness consumers.
    </div>
    <div className="screen-img">
      <img className="screenshot-img" src={DailyMacrosImg} alt="" />
    </div>
    <div className="text">
      After about a year of discovery, wireframes, and now development, the finished product now features online workout
      programs with a personal approach.
    </div>
    <div className="text">
      Apart from one-on-one training sessions and virtual sessions that include video calls with live trainers, the
      Omni-Active® Fitness app showcases online training with complete written workouts and videos – all in one place.
    </div>
    <div className="text">
      “This new model will allow us to make a bigger impact on the community by offering corporate wellness programs and
      by making ourselves more accessible to all of our clients. Convenience is still the motto, but the troubles of
      yesterday have set us up to make a bigger impact on tomorrow,” says Nithanial.
    </div>
    <div className="text">
      In a review, Scott lauded Omni-Active® Fitness for having top-notch personal trainers that pushed him to find his
      limits while at the same time motivating him to meet his goals.
    </div>
    <div className="text">
      “My trainer, Dustin, has been amazing. He is a beast. He is always encouraging me and motivating me to do my best.
      The work is difficult, but the results are worth it. The exercise, diet/meal plans, and motivation are paying off.
      I’m losing weight, feeling good, and getting into shape,” Scott wrote in a review.
    </div>
    <div className="text">
      Founded in 2012, Omni-Active® has led the pack in bringing training straight to homes. It has professional
      trainers to help people exercise efficiently, no matter where they are in the greater Cleveland area. With the
      addition of their app, they will look to expand to other cities in the near future.
    </div>
    <div className="text">
      The first consultation is free and includes a health questionnaire and movement assessment. The sessions are
      flexible as well.
    </div>
    <div className="text extra-space-down">
      Those who wish to learn more about Omni-Active® Fitness may visit the website for information.
    </div>
    <div className="line-break" />
  </div>
);
export default HomeTownFitness;
